/**
 * AI Settings Dialog
 *
 * Module-specific wrapper around the shared ExposedValueSettingsDialog.
 * Provides AI-specific translation prefix and fallback strings.
 */

import { ExposedValueSettingsDialog } from "@/core/components/exposed-values/ExposedValueSettingsDialog";
import type {
  Area,
  ExposedValueDefinition,
  ExposedValueMapping,
  Line,
  LocationScope,
  RealTimeValue,
  Station,
} from "../types";

interface AISettingsDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  exposedValues: ExposedValueDefinition[];
  factoryScope: LocationScope;
  areas: Area[];
  lines: Line[];
  stations: Station[];
  hasDatapoints: boolean;
  realTimeValues: Record<string, RealTimeValue>;
  getMappingForScope: (scope: LocationScope, exposedValueId: string) => ExposedValueMapping | null;
  onSelectMapping: (scope: LocationScope, definition: ExposedValueDefinition) => void;
  onOpenChart: (mapping: ExposedValueMapping) => void;
}

export const AISettingsDialog = ({
  open,
  onOpenChange,
  exposedValues,
  factoryScope,
  areas,
  lines,
  stations,
  hasDatapoints,
  realTimeValues,
  getMappingForScope,
  onSelectMapping,
  onOpenChart,
}: AISettingsDialogProps) => {
  return (
    <ExposedValueSettingsDialog
      open={open}
      onOpenChange={onOpenChange}
      translationPrefix="mod_ai.ai_production"
      titleFallback="AI Production Settings"
      descriptionFallback="Configure AI inference data mappings for the factory hierarchy"
      exposedValues={exposedValues}
      factoryScope={factoryScope}
      areas={areas}
      lines={lines}
      stations={stations}
      hasDatapoints={hasDatapoints}
      realTimeValues={realTimeValues}
      getMappingForScope={getMappingForScope}
      onSelectMapping={onSelectMapping}
      onOpenChart={onOpenChart}
    />
  );
};
